/* src/app/order/components/contact-person/contact-person.style.scss */
.email-hint {
  color: #8C8C8C;
  font-size: 12px;
  line-height: 1.33;
  margin-top: 6px;
}
.company-input-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  display: block;
  text-transform: uppercase;
}
.phone-row {
  display: flex;
  flex-wrap: nowrap;
}
.phone-row #contact-person-phone-country-code {
  max-width: 160px;
  margin-right: 20px;
}
.phone-row .form-input {
  display: flex;
}
.phone-row .form-input .phone-number {
  width: 100%;
}
.change-email-info {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.33;
  color: #007d40;
}
.label-flex {
  display: flex;
}
.optional-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  text-align: right;
  color: #8C8C8C;
  margin-left: auto !important;
  vertical-align: middle;
  text-align: right;
}
[nbInput].status-basic:disabled.contact-person-email-input {
  background-color: #f5f5f5;
  color: #585858;
}
/*# sourceMappingURL=contact-person.style.css.map */
